import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import { AuthCallback, Profile } from "./pages/AuthPages";
import Home from "./pages/Home";
import Library from "./pages/Library";
import FrameworkDetail from "./pages/FrameworkDetail";
import Glossary from "./pages/Glossary";
import UsaHub from "./pages/UsaHub";
import RegulatorDetail from "./pages/RegulatorDetail";
import MoneyFlow from "./pages/MoneyFlow";
import { Automations, AutomationDetail } from "./pages/Automations";
import { Tools, ToolDetail } from "./pages/Tools";
import Pulse from "./pages/Pulse";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render — process session_id BEFORE any route/auth logic
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/library" element={<Library />} />
      <Route path="/library/:slug" element={<FrameworkDetail />} />
      <Route path="/glossary" element={<Glossary />} />
      <Route path="/usa" element={<UsaHub />} />
      <Route path="/usa/:slug" element={<RegulatorDetail />} />
      <Route path="/money-flow" element={<MoneyFlow />} />
      <Route path="/automations" element={<Automations />} />
      <Route path="/automations/:slug" element={<AutomationDetail />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/tools/:slug" element={<ToolDetail />} />
      <Route path="/pulse" element={<Pulse />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/signup" element={<Auth mode="signup" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <AppRouter />
          <Footer />
          <ChatWidget />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
